import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppConfig } from './app-config';
import { BaseService } from './base/base.service';
import { PagedResponse } from './../interfaces/response';
import { AdjustmentType } from '../models';

@Injectable()
export class AdjustmentTypesService extends BaseService<AdjustmentType> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public listForTba(tbaId: number): Observable<PagedResponse<AdjustmentType>> {
    return this.http.get<PagedResponse<AdjustmentType>>(`${this.getResourceUrl()}tba/${tbaId}`);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}adjustment-types/`;
  }
}
